'use strict'
const axios = require('axios');

// Production Feature Flags endpoint
const FF_ENDPOINT='https://api.cloud.nuskin.com/feature-flags/v1/proxy'

// The local variable toggles is used to store the retrieved toggles
let toggles = [];

/**
 * retrieveToggles is a function to retrieve the feature toggles from a given URL.
 * (e.g., https://devapi.cloud.nuskin.com/feature-flags/v1/proxy)
 *
 * @param {string} url the URL for the retrieval of the feature flags
 * @param {string} userId an optional userId for the targeted user
 */
async function retrieveToggles(url, userId) {
    // Make sure there is no query parameter for the URL
    if (url && (url.indexOf('?') === -1)) {
        // Make sure that the userId does NOT contain
        if (userId) {
            if (userId.indexOf('&') >= 0) {
                console.error('Unexpected character in userId:', userId);
            } else {
                url += `?userId=${userId}`;
            }
        }
        try {
            const response = await axios.get(url);
            if (Array.isArray(response.data.toggles)) {
                toggles = response.data.toggles;
            } else {
                console.error('Invalid toggles (should be an array)');
            }
        } catch (err) {
            console.error('Cannot retrieve toggles:', err);
        }
    } else {
        console.error('Invalid url to retrieve feature flags, url=', url);
    }
}

/**
 * retrieveProductionToggles is a function to just retrieve the feature toggles from Production.
 *
 * @param {string} userId an optional userId for the targeted user
 */
async function retrieveProductionToggles(userId) {
    await retrieveToggles(FF_ENDPOINT, userId);
}

/**
 * isEnabled is a function to check if a given toggleName is enabled.
 *
 * @param {string} toggleName the name of the feature flag to check
 * @return {boolean} to indicate if the feature flag is enabled or not
 */
function isEnabled(toggleName) {
    let rv = false;
 
    const filtered = toggles.filter(toggle => toggle.name === toggleName);
    if (filtered.length > 0) {
        rv = filtered[0].enabled;
    }
 
    return rv;
}

module.exports = {
    retrieveToggles, retrieveProductionToggles, isEnabled
}
